import { transparentize } from 'polished'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const DraggableModalStyled = styled(Modal)`
    top: 0;
    left: 0;
    right: unset;
    bottom: unset;
    overflow: unset;
    box-shadow: 0 0 8px 2px
        ${({ theme }) => transparentize(0.9, theme.themeName === 'dark' ? theme['gray-0'] : theme['gray-1000'])};

    .modal-dialog {
        max-width: 100%;
        width: 100%;
        height: 100%;
        max-height: 100%;
        margin: 0;

        .modal-content {
            border-radius: 4px;
            overflow: hidden;

            .modal-header {
                position: relative;
                cursor: move;
                background: ${({ theme }) => theme['gray-0']};
                color: ${({ theme }) => theme['gray-1000']};
                border-bottom: 1px solid ${({ theme }) => theme['gray-400']};

                .modal-title {
                    color: ${({ theme }) => theme['gray-1000']};
                }

                button {
                    position: absolute;
                    height: 36px;
                    width: 36px;
                    top: calc(50%);
                    transform: translateY(-50%);
                    right: 4px;
                    border: none;
                    border-radius: 3px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: transparent;
                    font-size: 16px;

                    :hover {
                        background: ${({ theme }) => theme['gray-100']};
                    }
                }
            }

            .modal-body {
                padding: 0;
                background: ${({ theme }) => theme['gray-100']};
                color: ${({ theme }) => theme['gray-1000']};
            }

            .modal-footer {
                button {
                    border-radius: 3px;
                }
            }
        }
    }
`
